import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { FormRow } from "./FormRow";

interface TextInputProps {
  label: string;
  required?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // Добавим обработчик
}

export const CheckboxInput: React.FC<TextInputProps> = ({
  label,
  required = false,
  checked,
  onChange,
}) => {

  return (
    <div className={`formField formRow`}>
      <div className="fieldName flex gap12">
        <input
          className="checkBoxInput"
          type="checkbox"
          checked={checked}
          onChange={onChange}
          required={required}
        />
        <span>{label}</span>
        {required && <span className="requireSymbol">*</span>}
      </div>
    </div>
  );
};
